import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['forwardFields', 'modeRadio']

  connect() {
    this.toggleForwardFields()
  }

  select() {
    this.toggleForwardFields()

    if (this.selectedMode() === 'browser' && 'Notification' in window && Notification.permission === 'default') {
      Notification.requestPermission()
    }
  }

  toggleForwardFields() {
    this.forwardFieldsTarget.classList.toggle('hidden', this.selectedMode() !== 'forward')
  }

  selectedMode() {
    return this.modeRadioTargets.find((radio) => radio.checked)?.value
  }
}
